import { registerSW } from 'virtual:pwa-register';

/**
 * Registra o Service Worker gerado pelo vite-plugin-pwa em produção.
 * Em dev, o módulo virtual existe mas é um no-op (devOptions.enabled=false).
 *
 * TODO M3.x: implementar UI de prompt de update (onNeedRefresh) e badge "offline-ready".
 */
export function setupServiceWorker(): (() => Promise<void>) | undefined {
  if (typeof window === 'undefined') return undefined;
  if (!('serviceWorker' in navigator)) return undefined;

  const updateSW = registerSW({
    onNeedRefresh() {
      // Placeholder — UI de update será implementada em M3.x.
    },
    onOfflineReady() {
      // Placeholder — toast "offline-ready" em M3.x.
    },
  });
  return updateSW;
}
